import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video--play",
  "use": "icon-video--play-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-video--play\"><rect x=\".5\" y=\".5\" width=\"79\" height=\"79\" rx=\"1.5\" fill=\"#000\" fill-opacity=\".5\" /><rect x=\".5\" y=\".5\" width=\"79\" height=\"79\" rx=\"1.5\" stroke=\"#fff\" /><path d=\"m50 40-15 8.66V31.34L50 40Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol